import React from 'react';
import { Layout } from 'antd';
import { useNavigate } from 'react-router-dom';
import RegisterForm from './RegisterForm';

const { Header, Content } = Layout;

interface RegisterPageProps {
  onRegister: (username: string, password: string, invitationCode: string) => Promise<void>;
}

const RegisterPage: React.FC<RegisterPageProps> = ({ onRegister }) => {
  const navigate = useNavigate();

  return (
    <Layout style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
      <Header style={{ 
        background: 'rgba(0, 21, 41, 0.9)', 
        color: 'white', 
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div 
          style={{ 
            color: 'white', 
            fontSize: '20px', 
            fontWeight: 'bold',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center'
          }}
          onClick={() => navigate('/')}
        >
          🔮 慧卜
        </div>
        <div style={{ color: 'white' }}>
          已有账户？
          <span 
            style={{ 
              marginLeft: '8px', 
              color: '#40a9ff', 
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
            onClick={() => navigate('/login')}
          >
            立即登录
          </span>
        </div>
      </Header>
      <Content style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        padding: '40px'
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '20px',
          padding: '40px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
          backdropFilter: 'blur(10px)',
          maxWidth: '400px',
          width: '100%'
        }}>
          <div style={{ 
            textAlign: 'center', 
            marginBottom: '30px' 
          }}>
            <h2 style={{ 
              fontSize: '24px', 
              color: '#333',
              marginBottom: '8px'
            }}>
              创建您的账户
            </h2>
            <p style={{ 
              color: '#666',
              margin: 0,
              marginBottom: '10px'
            }}>
              立即注册，免费体验50次解读
            </p>
            <div style={{
              background: 'linear-gradient(90deg, #667eea, #764ba2)',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '20px',
              fontSize: '14px',
              display: 'inline-block'
            }}>
              🎁 新用户专享优惠
            </div>
          </div>
          
          <RegisterForm
            onRegister={onRegister}
            onBackToLogin={() => navigate('/login')}
            showBackButton={false}
          />
        </div>
      </Content>
    </Layout>
  );
};

export default RegisterPage;